import React, { useState, useEffect, useContext } from 'react';
import withAppContext from 'tbk-components/src/hooks/withAppContext';
import Location, {ILocation} from './index';
import Loading from "tbk-components/src/components/Loading";
import useHashAsState from 'tbk-components/src/hooks/useHashAsState';
import LocationMobileNav from "./LocationMobileNav";

/**
 * @useTermData
 * @taxonomy location-type
 */
export interface ILocationType {
	term_id: any;
}

/**
 * @usePostData
 * @post_type location
 */
export interface ILocationPost {
	post_id?: any;
}

export interface IContext {
	Api: {
		getLocations: (state: any) => Promise<ILocation[]>;
	};
}

export interface IAllLocationsProps {
	/** @noui */
	context: IContext;
	listView?: boolean;
	locationType?: ILocationType;
	/**
	 * Select a single location to display. This will override the Location Type filter.
	 */
	singleLocation?: ILocationPost;
	hideSearchBar?: boolean;
	hideViewToggle?: boolean;
	/**
	 * Default zoom level for the map.
	 */
	defaultZoom?: '4' | '6' | '8' | '10' | '12' | '14' | '16' | '18' | '20';
	/**
	 * @noUI
	 */
	mobileVersion?: boolean;
	/**
	 * @noUI
	 */
	mobileHeading?: string;
	/**
	 * @noUI
	 */
	defaultState?: any;
	/**
	 * @noUI
	 */
	defaultLocations?: ILocation[];
	/**
	 * @noUI
	 */
	hashAsState?: boolean;
	sectionTitle?: string;
}

/**
 * Display all the locations
 * @block
 * @icon location
 */
const AllLocations: React.FC<IAllLocationsProps> = withAppContext( ({
	context,
	listView = false,
	locationType,
	singleLocation,
	hideSearchBar = false,
	hideViewToggle = false,
	defaultZoom,
	mobileVersion = false,
	mobileHeading,
	defaultState,
	defaultLocations,
	hashAsState = false,
	sectionTitle
}) => {
	const { Api } = useContext( context );
	const singleLocationId = (singleLocation as any)?.ID;
	const [ locations, setLocations ] = useState( defaultLocations );
	const [ initialState ] = useHashAsState({
		parameters: {
			search: 'string',
			type: 'int',
		},
		defaults: {
		},
	});

	const [ definedState, setDefinedState ] = useState( {search:'',type:locationType?.term_id} );

	const [ state, setState ] = useState( hashAsState ? initialState : ( definedState.type ? definedState : ( defaultState || {} ) ) );
	useEffect( () => {
		if ( singleLocationId ) {
			Api.getLocations( { post__in: [ singleLocationId ] } ).then( locations => {
				setLocations( locations );
			} );
			return;
		}
		if ( locations ) {
			return;
		}
		Api.getLocations( state ).then( locations => {
			setLocations( locations );
		} )
	}, [ state, singleLocationId ] );

	if ( ! locations ) {
		return <div className="d-flex justify-content-center">
			<Loading />
		</div>;
	}

	const onSearchBarSubmit = ( newState ) => {
		setState( newState );
		setLocations( null );
	}
	return mobileVersion
		? <LocationMobileNav locations={locations} mobileHeading={mobileHeading} onSearchBarSubmit={onSearchBarSubmit} defaultState={state} includeTypeDropdownOnSearch={! defaultState?.type && ! locationType?.term_id }/>
		: <Location listView={ listView } locations={ locations } onSearchBarSubmit={onSearchBarSubmit} hashAsState={hashAsState} defaultState={state} includeTypeDropdownOnSearch={! defaultState?.type && ! locationType?.term_id } hideSearchBar={hideSearchBar} hideViewToggle={hideViewToggle} mapOptions={ defaultZoom ? { zoom: parseInt(defaultZoom, 10) } : {} } sectionTitle={sectionTitle} />
})
export default AllLocations;
